export function removeToken() {
  localStorage.removeItem('token')
  sessionStorage.removeItem('token')
}

export function getToken() {
  const tokenString = localStorage.getItem('token')
  if (tokenString) {
    const { token, expireTime } = JSON.parse(tokenString)
    const now = new Date().getTime()
    if (expireTime >= now) {
      return token
    } else {
      removeToken()
      return null
    }
  } else {
    const tempToken = sessionStorage.getItem('token')
    if (tempToken) {
      return tempToken
    } else {
      removeToken()
      return null
    }
  }
}

export function setToken(token: string, remember: boolean) {
  if (remember) {
    removeToken()
    const expireTime = new Date().getTime() + 604800000
    localStorage.setItem('token', JSON.stringify({ token, expireTime }))
  } else {
    removeToken()
    sessionStorage.setItem('token', token)
  }
}

export function removeSchoolInfo() {
  localStorage.removeItem('schoolInfo')
}

export function getSchoolInfo() {
  const schoolInfo = localStorage.getItem('schoolInfo')
  if (schoolInfo) {
    return JSON.parse(schoolInfo)
  } else {
    return null
  }
}

export function setSchoolInfo(schoolInfo) {
  removeSchoolInfo()
  localStorage.setItem('schoolInfo', JSON.stringify(schoolInfo))
}

export function removeRoleType() {
  localStorage.removeItem('roleType')
}

export function getRoleType() {
  return localStorage.getItem('roleType') || ''
}

export function setRoleType(roleType: string) {
  removeRoleType()
  localStorage.setItem('roleType', roleType)
}

export function removeAgencyId() {
  localStorage.removeItem('agencyId')
}

export function getAgencyId() {
  return localStorage.getItem('agencyId') || ''
}

export function setAgencyId(agencyId: string) {
  removeAgencyId()
  localStorage.setItem('agencyId', agencyId)
}

export function getLocale() {
  return localStorage.getItem('locale') || 'zh'
}

export function setLocale(locale: string) {
  return localStorage.setItem('locale', locale)
}
